<template>
  <section
    class="card"
    @mouseover="$emit('mouseover')"
    @mouseleave="$emit('mouseleave')"
  >
    <slot></slot>
  </section>
</template>

<script>
  export default {
    name: 'card',
  };
</script>



// WEBPACK FOOTER //
// src/components/Card.vue